import RolesContainer from './RolesContainer';

export default { RolesContainer };
